import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './home';
import Privacy from './privacy';
import Terms from './terms_of_service';
import Codex from './user_safety_codex';
import ScriptLoader from './components/ScriptLoader';

function App() {
  return (
    <>
      <ScriptLoader />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms_of_service" element={<Terms />} />
        <Route path="/user_safety_codex" element={<Codex />} />
      </Routes>
    </>
  );
}

export default App;
